import { CrudManager } from "./CrudManager";

export default function AdminDoctors() {
  return (
    <CrudManager
      testidPrefix="admin-doctors"
      title="Doctors"
      description="Manage doctor profiles displayed on the public site."
      endpoint="/admin/doctors"
      columns={[
        { key: "photo_url", label: "Photo" },
        { key: "name", label: "Name" },
        { key: "specialty", label: "Specialty" },
        { key: "schedule", label: "Schedule" },
      ]}
      renderCell={(key, it) => {
        if (key === "photo_url") return it.photo_url ? <img src={it.photo_url} alt="" className="w-10 h-10 rounded-full object-cover" /> : <div className="w-10 h-10 rounded-full bg-slate-100" />;
        return it[key];
      }}
      emptyValues={{ name: "", specialty: "", qualifications: "", bio: "", photo_url: "", schedule: "", phone: "", email: "", order: 0 }}
      fields={[
        { name: "name", label: "Full name", type: "text" },
        { name: "specialty", label: "Specialty", type: "text" },
        { name: "qualifications", label: "Qualifications", type: "text" },
        { name: "bio", label: "Bio", type: "textarea" },
        { name: "photo_url", label: "Photo URL", type: "url" },
        { name: "schedule", label: "Schedule", type: "text", placeholder: "Mon–Fri, 10:00 AM – 2:00 PM" },
        { name: "phone", label: "Phone", type: "text" },
        { name: "email", label: "Email", type: "email" },
        { name: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
